/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.10.2",
    versionName: "0.2.0-nightly.2025.10.2",
    versionChannel: "nightly",
    buildDate: "2025-10-02T00:07:26.269Z",
    commitHash: "3d61091506f347f2ce861b56e35cfb57c68dcb47",
};
